// define a mixin object
export default {
  methods: {
    backendErrorNotify(err) {
      let tempMessage = ''
      if (err.response) {
        Object.keys(err.response.data.message).forEach(key => {
          tempMessage += err.response.data.message[key].reduce(
            (acc, cur) => acc.slice(0, -1) + ', ' + cur.slice(0, -1)
          )
        })
      }
      tempMessage = tempMessage + '.'
      this.$notify.error({
        title: this.$t('error'),
        message: tempMessage,
        offset: 300,
      })
    },
    backendWarningMsg(res) {
      let backendMess = ''
      if (res) {
        Object.keys(res.data.message).forEach(key => {
          backendMess += res.data.message[key].reduce(
            (acc, cur) => acc.slice(0, -1) + ', ' + cur.slice(0, -1)
          )
        })
      }
      this.$notify.warning({
        title: this.$t('warning'),
        message: backendMess,
        offset: 300,
      })
    },
    backendSuccessMsg(res) {
      let backendMess = ''
      if (res) {
        Object.keys(res.data.message).forEach(key => {
          backendMess += res.data.message[key].reduce(
            (acc, cur) => acc.slice(0, -1) + ', ' + cur.slice(0, -1)
          )
        })
      }
      this.$notify.success({
        title: this.$t('success'),
        message: backendMess,
        offset: 300,
      })
    },
    formatProtocol({ protocol, number, date }) {
      if (number && date) {
        const dateOnly = date.split(' ')[0]
        const [year, month, day] = dateOnly.split('-')
        if (!year || !month || !day) {
          return 'Μη έγκυρη μορφή ημερομηνίας'
        }
        return `${number}(${day}/${month}/${year})`
      }

      if (protocol) {
        const regex = /^(.+?)\((\d{4})-(\d{2})-(\d{2})\)$/
        const match = protocol.match(regex)
        if (!match) {
          return 'Μη έγκυρη μορφή πρωτοκόλλου'
        }
        const [, prefix, year, month, day] = match
        return `${prefix}(${day}/${month}/${year})`
      }

      return 'Απαιτείται protocol ή number και date'
    },
  },
}
